const ButtonSelectContainerStyle = `
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  grid-column-gap: 17px;
  width: max-content;
`;

export default ButtonSelectContainerStyle;
